export enum SectionTypes {
  Logotypes = 'sectionLogos',
  Quote = 'sectionQuote',
  ProductsList = 'sectionProductsList',
  SingleProduct = 'sectionSingleProduct',
  SectionHero = 'sectionHero',
}
